// ---------------------------------------------------------------------------
// PORTÃO da TELA DE ESCOLHA DE FILIAL (multi-filiais, modoEntrada = 'tela').
//
// É a única parte que entra no bundle de TODO site, por isso é mínima: decide se
// o tenant está no modo tela e, só então, traz a tela (JS + CSS em chunk
// próprio) e o CSS/script inline do <head> que a faz nascer na 1ª pintura.
// Qualquer outro tenant recebe `null` — zero markup, zero CSS, zero listener.
//
// A tela é renderizada no SERVIDOR (dynamic com SSR), sempre escondida: o HTML
// é o mesmo para todo visitante e continua cacheável. Quem decide mostrar é o
// script inline (antes da hidratação) e o componente (depois).
// ---------------------------------------------------------------------------
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useMemo } from 'react';
import { useRegiao } from '../../context/Info';
import { buildFilialTelaBootstrap, isModoTela } from '../../../lib/region';
import { usePreviaBuilder } from '../../../lib/previaBuilder';

const FilialTela = dynamic(() => import('./FilialTela'));

const FilialTelaPortao = () => {
    const { regioes, regioesConfig } = useRegiao();
    // prévia do CRM (`?tema=filiais:fechado`): sem a tela de escolha (nem o script do <head>)
    const { filiaisFechado } = usePreviaBuilder();
    const modoTela = isModoTela(regioes, regioesConfig);
    const lembrarDias = regioesConfig?.lembrarDias;
    const boot = useMemo(
        () => (modoTela ? buildFilialTelaBootstrap(lembrarDias) : null),
        [modoTela, lembrarDias]
    );

    if (!boot || filiaisFechado) return null;

    return (
        <>
            <Head>
                <style key="filial-tela-css" dangerouslySetInnerHTML={{ __html: boot.css }} />
                {/* data-cfasync="false": o Rocket Loader do Cloudflare ADIA todo <script> (inline
                    inclusive) para depois do parse — a classe chegaria tarde e o site piscaria
                    por baixo da tela. Este atributo é o opt-out oficial: roda na hora, no <head>. */}
                {/* eslint-disable-next-line @next/next/no-sync-scripts */}
                <script
                    key="filial-tela-boot"
                    data-cfasync="false"
                    dangerouslySetInnerHTML={{ __html: boot.script }}
                />
            </Head>
            <FilialTela />
        </>
    );
};

export default FilialTelaPortao;
